import { IZendeskArticle } from "@faire/web-api--source/com/faire/vendor/zendesk/IZendeskArticle";

import {
  IArticleWithPreview,
  ITopic,
  ITopicPlaceholder,
} from "../types/topics";
import { ISection } from "../types/zendesk";

import { getArticlePreview } from "./articleFormatter";
import { topicPlaceHolder } from "./random";

export const getTopic = (
  isLoading: boolean,
  sections: ISection[],
  topicId: number | undefined
): ITopicPlaceholder => {
  if (isLoading) {
    return topicPlaceHolder;
  }

  const currentTopic = sections.find((section) => section.id === topicId);
  if (!currentTopic) {
    return topicPlaceHolder;
  }

  const topic: ITopic = {
    ...currentTopic,
    articles: currentTopic.articles
      .filter((article) => !article.draft)
      ?.map((article) => toArticleWithPreview(article, currentTopic.name)),
  };

  return topic;
};

/**
 * Transforms an IZendeskArticle to an IArticleWithPreview
 */
export const toArticleWithPreview = (
  article: IZendeskArticle,
  section_name?: string | undefined
): IArticleWithPreview => {
  return {
    ...article,
    section_name,
    preview: getArticlePreview(article),
  };
};
